/**
 * Mobile app (Capacitor, Android) detection — tiny and dependency-free, so it can sit in the entry
 * bundle. Everything native lives in `./native.ts` / `./MobileShell.tsx`, which are only ever
 * loaded with a dynamic import() when this returns true. The web build is unaffected.
 * See _specs/mobile/MOBILE_PLAN.md.
 */
type CapacitorGlobal = { isNativePlatform?: () => boolean; getPlatform?: () => string }

export function isNativeApp(): boolean {
  try {
    return typeof window !== 'undefined' && !!(window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor?.isNativePlatform?.()
  } catch {
    return false
  }
}

/** Work the app must finish BEFORE the session ends (e.g. unregister this phone from push). */
const beforeLogoutHooks = new Set<() => Promise<void>>()

export function onBeforeLogout(fn: () => Promise<void>): () => void {
  beforeLogoutHooks.add(fn)
  return () => { beforeLogoutHooks.delete(fn) }
}

export async function runBeforeLogout(): Promise<void> {
  await Promise.allSettled([...beforeLogoutHooks].map((fn) => fn()))
}
